module.exports = __webpack_public_path__ + "static/media/download.53a0421a.pdf";